import React from 'react';
import { FadeIn } from './FadeIn';
import { XCircle } from 'lucide-react';
const failures = ['Las agendas genéricas de Target no entienden la volatilidad de trabajar con dueños de negocio intensos.', 'Las apps de productividad como Notion se convierten en "cementerios de tareas" si no tienen una jerarquía lógica.', 'El multitasking no es una habilidad, es una fuga de dinero que reduce tu valor por hora en un 40%.', 'Decir "sí" a todo no te hace indispensable, te hace invisible frente a los clientes que realmente pagan bien.'];
export function FailedMethodsSection() {
  return <section className="py-20 md:py-28 bg-brand-cream" data-id="element-35">
      <div className="max-w-5xl mx-auto px-6 lg:px-8" data-id="element-36">
        <FadeIn data-id="element-37">
          <div className="text-center mb-16" data-id="element-38">
            <h2 className="text-3xl md:text-4xl font-bold text-brand-charcoal mb-4" data-id="element-39">
              Por qué lo que has intentado no funciona
            </h2>
            <div className="w-24 h-1 bg-brand-gold mx-auto" data-id="element-40"></div>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-41">
          {failures.map((text, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-42">
              <div className="bg-white p-8 rounded-sm shadow-sm border border-brand-charcoal/5 h-full flex items-start space-x-4 hover:shadow-md transition-shadow" data-id="element-43">
                <XCircle className="w-6 h-6 text-brand-gold flex-shrink-0 mt-1" data-id="element-44" />
                <p className="text-brand-charcoal/80 leading-relaxed" data-id="element-45">{text}</p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}